export async function requestAppTweakApiData(params: Record<string, string>) {
  const apiBaseUrl = process.env.PARCEL_API_URL || "";
  const endpointPath = "/api/apptweak/application-metadata";
  const search = new URLSearchParams(params).toString();
  // Always expect endpointPath to start with '/'
  const url = `${apiBaseUrl}${endpointPath}${search ? `?${search}` : ""}`;
  const res = await fetch(url);
  if (!res.ok) {
    let message = "Failed to fetch AppTweak data";
    try {
      const err = await res.json();
      if (err && err.error) message = err.error;
    } catch {}
    throw new Error(message);
  }
  return res.json();
}
